import { cn } from '@crossnokaye/ux-common';

interface ScrollContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const ScrollContainer = ({ children, className, ...props }: ScrollContainerProps) => {
  return (
    <div
      className={cn(
        '@container/scroll-container flex min-w-0 flex-col flex-1 overflow-hidden overflow-y-auto min-h-0',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
